module.exports = __webpack_public_path__ + "img/16_22.97c6c9a6.png";